import React from 'react'
import classNames from 'classnames'

import T from 'components/FormattedMessage'
import Button from 'components/Button'
import UserPhoto from 'components/UserPhoto'
import GeneralListItem from 'components/GeneralListItem'

import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import { IUser, UserRelationship } from 'protos'

import facebookBadgeUrl from 'assets/images/facebook.svg'

interface Props {
  friend: IUser
  selected?: boolean
  onChallengeClick?: () => void
  onClick?: () => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    paddingLeft: theme.spacing(),
  },
  profileImage: {
    marginLeft: theme.spacing(),
  },
  selected: {
    borderLeftColor: theme.palette.primary.main,
    borderLeftWidth: theme.spacing(),
    borderLeftStyle: 'solid',
    paddingLeft: 0,
    backgroundColor: theme.palette.grey['200'],
  },
  facebookBadge: {
    position: 'absolute',
    backgroundColor: '#fff',
    display: 'block',
    borderRadius: 9,
    padding: 2,
    height: 14,
    width: 14,
    zIndex: 1,
    right: -3,
    top: -3,
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const FriendListItem: React.SFC<InjectedProps> = ({ friend, selected, onClick, onChallengeClick, classes }) => {
  const incomingRequest = friend.relationship === UserRelationship.UR_INCOMING

  return (
    <GeneralListItem
      button
      onClick={onClick}
      className={classNames(classes.root, { [classes.selected]: selected })}
      headline={friend.name}
      subtitle={incomingRequest && <T id="userprofile_incomingrelationshipinfo" />}
      subtitleVariant="h3"
      leftChild={(
        <div style={{ position: 'relative' }}>
          {friend.facebookFriend && <img alt="" src={facebookBadgeUrl} className={classes.facebookBadge} />}
          <UserPhoto src={friend.photoUrl!} className={classes.profileImage} />
        </div>
      )}
      rightChild={onChallengeClick && !incomingRequest && (
        <Button
          variant="contained"
          color="secondary"
          onClick={(ev) => { ev.stopPropagation(); if (onChallengeClick) { onChallengeClick() } }}
          onMouseDown={(ev) => { ev.stopPropagation() }}
        >
          <T id="friends_action_challenge" />
        </Button>
      )}
    />
  )
}

export default withStyles(styles)(FriendListItem)
